module.exports = __webpack_public_path__ + "media/images/logo-white-2-8543d99f8f09929b33dfcb5a0ff55ad6.svg";